import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';

const LegalPage = () => {
  const { language } = useLanguage();

  const content = {
    fr: {
      title: "Mentions légales",
      sections: [
        {
          title: "Éditeur du site",
          content: "BAO Agency\nAgence de marketing digital\nParis, France\nEmail: contact@baoagency.fr"
        },
        {
          title: "Hébergement",
          content: "Le site est hébergé par nos partenaires technologiques."
        },
        {
          title: "Propriété intellectuelle",
          content: "L'ensemble de ce site relève de la législation française et internationale sur le droit d'auteur et la propriété intellectuelle. Tous les droits de reproduction sont réservés, y compris pour les documents téléchargeables et les représentations iconographiques et photographiques."
        },
        {
          title: "Protection des données personnelles",
          content: "Conformément à la loi « Informatique et Libertés » du 6 janvier 1978 modifiée et au Règlement Général sur la Protection des Données (RGPD), vous disposez d'un droit d'accès, de rectification, d'effacement et de portabilité des données vous concernant."
        },
        {
          title: "Cookies",
          content: "Ce site utilise des cookies pour améliorer votre expérience de navigation. En continuant à utiliser ce site, vous acceptez notre utilisation des cookies."
        }
      ]
    },
    en: {
      title: "Legal Notice",
      sections: [
        {
          title: "Site Publisher",
          content: "BAO Agency\nDigital Marketing Agency\nParis, France\nEmail: contact@baoagency.fr"
        },
        {
          title: "Hosting",
          content: "The site is hosted by our technology partners."
        },
        {
          title: "Intellectual Property",
          content: "This entire site is subject to French and international copyright and intellectual property law. All reproduction rights are reserved, including for downloadable documents and iconographic and photographic representations."
        },
        {
          title: "Personal Data Protection",
          content: "In accordance with the Data Protection Act and the General Data Protection Regulation (GDPR), you have the right to access, rectify, delete and port your personal data."
        },
        {
          title: "Cookies",
          content: "This site uses cookies to improve your browsing experience. By continuing to use this site, you accept our use of cookies."
        }
      ]
    }
  };

  const currentContent = content[language];

  return (
    <main className="min-h-screen pt-28 pb-16 bg-white" data-testid="legal-page">
      <div className="container-custom">
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="heading-xl text-4xl md:text-5xl mb-12 text-black"
          data-testid="legal-title"
        >
          {currentContent.title}
        </motion.h1>

        <div className="max-w-3xl space-y-8">
          {currentContent.sections.map((section, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="p-6 bg-neutral-50 rounded-2xl"
              data-testid={`legal-section-${index}`}
            >
              <h2 className="font-serif text-xl font-semibold mb-4 text-black">
                {section.title}
              </h2>
              <p className="font-sans text-neutral-600 leading-relaxed whitespace-pre-line">
                {section.content}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </main>
  );
};

export default LegalPage;
